import React from 'react';

import { graphql, useStaticQuery } from 'gatsby';

import styles from './TermsOfService.module.css';

import Container from '../../../blocks/Container';

const TermsOfService = () => {
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark(filter: { fileAbsolutePath: { regex: "/tos.md/" } }) {
        edges {
          node {
            html
          }
        }
      }
    }
  `);

  const { html } = data.allMarkdownRemark.edges[0].node;

  return (
    <div className={styles.termsOfService}>
      <Container type="big">
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </Container>
    </div>
  )
};

export default TermsOfService;